export default function bindProperty(value: any): any {
  return value || '';
}
